import { Directive, Input } from '@angular/core';
import { Globals } from '../app/app.globals';

@Directive({
    selector: 'img[default-src]',
    host: {
        '(error)': 'updateUrl()',
        '[src]': 'src'
    }
})

//  Purpose of this Directive is to make sure if image loads fail, load the default image in it.

export class DefaultImage {
    @Input() src: string;
    defaultImage: string = new Globals().domain + 'images/defult_art.jpg';

    updateUrl() {
        this.src = this.defaultImage;
    }
}



// WEBPACK FOOTER //
// ./src/directives/default-image.ts